<template>
  <v-main>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <v-row justify="center" class="mb-8 my-6">
        <v-btn color="doorMainColor" dark x-large class="mb-4 mx-4 white--text">
          <v-icon left class="mr-2">mdi-arrow-collapse-down</v-icon>
          <download-csv
            :data="json"
            :labels="labels"
            :fields="fields"
          >
            CSVダウンロード
          </download-csv>
        </v-btn>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { Logger } from 'aws-amplify';
import { useStore } from 'vuex';
import { useMedicalRecordFormatter } from '@/func/useMedicalRecordFormatter';

const logger = new Logger('AdminsCsvDownload');

export default defineComponent({
  setup() {
    logger.info('AdminsCsvDownload');
    const store = useStore();
    const formatter = useMedicalRecordFormatter();

    const fetchMedicalRecords = async () => {
      try {
        await store.dispatch('medicalRecords/getMedicalRecords');
      } catch (e) {
        logger.info(e);
      }
    };
    fetchMedicalRecords();

    const json = computed(() => {
      const data = formatter.toCsvDownload(store.state.medicalRecords.records);
      logger.info('json', data);
      return data;
    });
    const labels = formatter.mapKeys;
    const fields = formatter.fields;

    return {
      json,
      labels,
      fields,
    };
  },
});
</script>

<style scoped>

</style>
